module.exports = __webpack_public_path__ + "static/media/capstone_permissions.b9e3319a.yaml";